import { IconToggleHeartOff24, IconToggleHeartOn24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as styles from './FavoriteButtonMobile.css';

export interface IFavoriteButtonMobileProps {
  isFavorite: boolean;
  onClick?(): void;
}

export const FavoriteButtonMobile: React.VFC<IFavoriteButtonMobileProps> = ({ isFavorite, onClick }) => {
  const HeartIcon = isFavorite ? IconToggleHeartOn24 : IconToggleHeartOff24;

  return (
    <button
      className={styles['button']}
      onClick={onClick}
      aria-label={isFavorite ? 'В избранном' : 'В избранное'}
      data-testid="FavoriteButtonMobile"
      type="button"
    >
      <HeartIcon color="icon-warning-default" />
    </button>
  );
};
